import DescriptionSkeleton from './DescriptionSkeleton';
export default DescriptionSkeleton;
